import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { BlockUiService } from '../services/ui/block-ui.service';
import { environment } from '../../../environments/environment';

export const blockUiInterceptor: HttpInterceptorFn = (req, next) => {
  const blockUiService: BlockUiService = inject(BlockUiService);

  const skipHeader = req.headers.get('X-Skip-BlockUI');
  const shouldSkip = skipHeader === 'true' || skipHeader === '1';
  const cleanedReq = shouldSkip
    ? req.clone({ headers: req.headers.delete('X-Skip-BlockUI') })
    : req;

  const isApiCall = cleanedReq.url.startsWith(environment.apiUrl);
  const isBlockableMethod = !['OPTIONS', 'HEAD'].includes(cleanedReq.method);
  const shouldBlock =
    blockUiService.activateBlockUI() && !shouldSkip && isApiCall && isBlockableMethod;

  if (shouldBlock) blockUiService.start();

  return next(cleanedReq).pipe(
    finalize(() => {
      if (shouldBlock) blockUiService.stop();
    }),
  );
};
